import { AsyncAction } from '../../../../../base-classes/asyncAction';
import { IPulseRequestConfiguration, PulseRequestConfiguration } from "../../../../types/PulseInterfaces";

// Related Hurricane Bulletin dependencies
import { HurricaneOutlookBulletinProvider } from "../../../../providers/Hurricane/Outlook/hurricaneOutlookBulletinProvider";

export const GET_HURRICANE_OUTLOOK_BULLETIN = new AsyncAction('GET_HURRICANE_OUTLOOK_BULLETIN');

export function getHurricaneOutlookBulletin(
	apiParameters: GetHurricaneOutlookBulletinActionParameters
) {
	const requestConfiguration = new PulseRequestConfiguration(apiParameters);
	const payload = getActionPayload({ ...apiParameters, ...requestConfiguration });
	return {
		type: GET_HURRICANE_OUTLOOK_BULLETIN.base,
		payload
	};
}

async function getActionPayload(apiParameters: GetHurricaneOutlookBulletinActionParameters) {
	const storeProvider = new HurricaneOutlookBulletinProvider(apiParameters);
	const payload = await storeProvider.getHurricaneOutlookBulletin(apiParameters);
	return payload;
}

/**
 * Input Parameters for making an API request to Pulse for getting a hurricane outlook bulletin 
 */
export interface GetHurricaneOutlookBulletinActionParameters extends IPulseRequestConfiguration {
	basin?: HurricaneOutlookBasinID;
}

export type AtlanticHurricaneBasinID = 'at';
export type CentralPacificHurricaneBasinID = 'cp';
export type EasternPacificHurricaneBasinID = 'ep';
export type HurricaneOutlookBasinID = string | AtlanticHurricaneBasinID | CentralPacificHurricaneBasinID | EasternPacificHurricaneBasinID;
